import React, { FC, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { BUTTON_TYPES, EvButton, EvFlexRow } from '@evinced-private/ui-common';

import { RoutesHelper } from 'src/helpers/RoutesHelper';

import { usePropertySettings } from '../context';

import { ACTIONS_LABELS } from './PropertySettingsActionsV2.labels';

export const PropertySettingsActionsV2: FC = () => {
	const {
		state: { isSaving },
		isListMode,
		submitSettings
	} = usePropertySettings();
	const history = useHistory();
	const location = useLocation<{ from: string }>();

	const onCancel = useCallback((): void => {
		const backUrl = location?.state?.from ?? RoutesHelper.getPropertiesPagePath();
		history.push(backUrl);
	}, [history, location?.state]);

	const onSave = useCallback((): void => {
		submitSettings(false);
	}, [submitSettings]);

	const onSaveAndCrawl = useCallback((): void => {
		submitSettings(true);
	}, [submitSettings]);

	return (
		<EvFlexRow
			justify="END"
			gap="SMALL"
			width="100%"
			data-automation-id="property-settings-actions"
		>
			<EvButton type={BUTTON_TYPES.SECONDARY} title={ACTIONS_LABELS.CANCEL} onClick={onCancel}>
				{ACTIONS_LABELS.CANCEL}
			</EvButton>
			<EvButton title={ACTIONS_LABELS.SAVE} loading={isSaving} onClick={onSave}>
				{ACTIONS_LABELS.SAVE}
			</EvButton>
			{!isListMode && (
				<EvButton title={ACTIONS_LABELS.SAVE_AND_CRAWL} loading={isSaving} onClick={onSaveAndCrawl}>
					{ACTIONS_LABELS.SAVE_AND_CRAWL}
				</EvButton>
			)}
		</EvFlexRow>
	);
};
